/* tslint:disable */
import icon from 'vue-svgicon'
icon.register({
  'profile-male': {
    width: 66,
    height: 66,
    viewBox: '0 0 66 66',
    data: `<defs><clipPath id="svgicon_profile-male_a"><path pid="0" d="M0 0h66v66H0z"/></clipPath></defs><g clip-path="url(#svgicon_profile-male_a)"><path pid="1" data-name="Profiel button" d="M65.501 33A32.5 32.5 0 0033.001.5 32.5 32.5 0 00.501 33a32.5 32.5 0 0032.5 32.5 32.5 32.5 0 0032.5-32.5z" _fill="none" _stroke="#000" stroke-width="1.189"/><g data-name="Group 1373" _fill="none" _stroke="#000"><g data-name="Ellipse 277" transform="translate(20.5 24.5)"><circle pid="2" cx="10" cy="10" r="10" _stroke="none"/><circle pid="3" cx="10" cy="10" r="9.5"/></g><path pid="4" data-name="Path 1494" d="M45.043 19.98l-7.83 7.806"/><path pid="5" data-name="Path 1492" d="M38.5 20h7"/><path pid="6" data-name="Path 1493" d="M45 26.5v-7"/></g></g>`
  }
})
/* tslint:enable */
